
<li class="clinic-sidebar__list-child" :class="{ '--active': isActive }">
  <slot name="sub-item-body" />
</li>
